import * as o from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/Atom.es.js";
const t = o.forwardRef((m, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...m, weights: a }));
t.displayName = "AtomIcon";
const n = t;
export {
  n as Atom,
  t as AtomIcon
};
